"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const TableSchemaContext_1 = require("./TableSchemaContext");
function useTableSchema() {
    const { tablesList, applicationsList, loading, error } = react_1.useContext(TableSchemaContext_1.TableSchemaContext);
    return {
        tablesList,
        applicationsList,
        loading,
        error,
    };
}
exports.useTableSchema = useTableSchema;
//# sourceMappingURL=useTableSchema.js.map